// src/slices/job/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getJobs, getJobByIdentifier, createJob, addJob, createJobApplication } from "./thunk";

const initialState = { jobs: [], singleJob: null, job: null, pagination: {}, loading: false, singleLoading: false, success: false, error: null };

const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // =========================
      // Get All Jobs
      // =========================
      .addCase(getJobs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getJobs.fulfilled, (state, action) => {
        state.loading = false;

        state.jobs = action.payload?.data?.data || action.payload?.jobs || action.payload || [];

        state.pagination = action.payload?.data?.responseDetails?.pagination || { currentPage: 1, totalPages: 1, totalItems: 0, limit: 10 };
      })

      .addCase(getJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error;
      })

      // =========================
      // Get Single Job
      // =========================
      .addCase(getJobByIdentifier.pending, (state) => {
        state.singleLoading = true;
        state.error = null;
      })

      .addCase(getJobByIdentifier.fulfilled, (state, action) => {
        state.singleLoading = false;

        state.singleJob = action.payload?.data || action.payload?.job || action.payload;
      })

      .addCase(getJobByIdentifier.rejected, (state, action) => {
        state.singleLoading = false;
        state.error = action.payload || action.error;
      })

      // =========================
      // Add Job (User)
      // =========================
      .addCase(addJob.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })

      .addCase(addJob.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.job = action.payload?.data || action.payload;
      })

      .addCase(addJob.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || action.error;
      })

      // =========================
      // Create Job (Admin)
      // =========================
      .addCase(createJob.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })

      .addCase(createJob.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.job = action.payload?.data || action.payload;
      })

      .addCase(createJob.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || action.error;
      })

      // job application
      .addCase(createJobApplication.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createJobApplication.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(createJobApplication.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  }
});

export default jobSlice.reducer;
